import {
  Alert,
  AlertTitle,
  Slide,
  type SlideProps,
  Snackbar,
} from "@mui/material";

import type { SnackbarMessage } from "./types";

import { useRemoveSnackbarMessage } from "./hooks/useRemoveSnackbarMessage";

export const SnackbarMessages = ({
  messages,
}: {
  messages: SnackbarMessage[];
}) => {
  const removeMessage = useRemoveSnackbarMessage();

  const onClose = () => {
    if (messages.length > 0) {
      removeMessage(messages[0]);
    }
  };

  const currentMessage = messages.length > 0 ? messages[0] : undefined;

  return (
    <Snackbar
      autoHideDuration={6000}
      onClose={onClose}
      open={currentMessage !== undefined}
      slots={{ transition: SlideTransition }}
    >
      {currentMessage && (
        <Alert
          onClose={onClose}
          severity={currentMessage.type}
          sx={{ minWidth: "300px", width: "100%" }}
          variant="filled"
        >
          {currentMessage.description ? (
            <>
              <AlertTitle>{currentMessage.message}</AlertTitle>
              {currentMessage.description}
            </>
          ) : (
            currentMessage.message
          )}
        </Alert>
      )}
    </Snackbar>
  );
};

function SlideTransition(props: Readonly<SlideProps>) {
  return <Slide {...props} direction="up" />;
}
